import React, { useState } from 'react';
import { Card, Form, Col, Row, Button, ListGroupItem, ListGroup } from 'react-bootstrap';
import { useContextInfo } from '../../context/ContextInfo';
import { fetchConToken } from '../../api/fetch';
import Confirmation from '../ui/Confirmation';
import { AiFillDelete } from 'react-icons/ai';
import { useForm } from '../../hooks/useForm';
const baseUrl = process.env.REACT_APP_API;

const CardApp = ({ bn, callBk }) => {
    const { setResp } = useContextInfo();
    const [showd, setShowd] = useState(false);
    const info = { id: bn.id, type: 'CARDAPP' };
    const [values, handleInputChange, reset, setFormValue] = useForm({
        titulo: bn.titulo || '',
        descripcion: bn.descripcion || '',
    });
    const { titulo, descripcion } = values;

    const onSubmit = async (e) => {
        e.preventDefault();
        const resp = await fetchConToken('main/cardapp', { id: bn.id, titulo, descripcion }, 'POST');
        setResp(resp);
        callBk();
    };
    return (
        <Card className="text-center" >
            <Card className="text-center">
                <Card className='p-4'>
                    <Card.Header>
                        Aviso{' '}
                        <AiFillDelete
                            className="fs-4 icon-link icon-link-hover link-danger link-underline-danger link-underline-opacity-75"
                            onClick={() => setShowd(true)}
                        />
                    </Card.Header>{' '}
                    <Card.Img variant="top" src={`${baseUrl}${bn.foto}`} />
                    <Card.Body>
                        <Card.Title>{titulo}</Card.Title>
                        <Card.Text>{descripcion}</Card.Text>
                    </Card.Body>
                </Card>
            </Card>

            <Form noValidate onSubmit={onSubmit}>
                <Card.Body>
                    <Col>
                        {' '}
                        <Form.Group className="mb-2">
                            <Form.Label>Titulo </Form.Label>
                            <Form.Control type="text" value={titulo} onChange={handleInputChange} name="titulo" />{' '}
                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                        </Form.Group>{' '}
                        <Form.Group className="mb-2">
                            <Form.Label>Descripción </Form.Label>
                            <Form.Control
                                type="text"
                                value={descripcion}
                                onChange={handleInputChange}
                                name="descripcion"
                            />{' '}
                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                        </Form.Group>{' '}
                    </Col>
                    <Button type="submit">Guardar cambios</Button>
                </Card.Body>
            </Form>
            <Confirmation show={showd} toggle={() => setShowd(false)} info={info} callBk={callBk} />
        </Card>
    );
};

export default CardApp;
